<template>
  <div>
  <v-data-table
    v-if="productsSelected.length"
    :headers="tables.headers"
    :items="productsSelected"
    hide-default-footer
    class="elevation-0 table-Installations mb-3"
  >
    <template v-slot:item.actions="{ item }">
      <v-icon
          color="rgba(0,0,0,.54)"
          class="size-30"
          @click="$emit('changePosition', item.listID)"
      >mdi-pencil</v-icon>
      <v-icon
          color="#ed1b24"
          class="size-30"
          @click="$emit('deleteproduct', item.listID)"
      >mdi-delete</v-icon>
    </template>
  </v-data-table>
  </div>
</template>

<script>
export default {
  props: ['productsSelected'],
  data() {
    return {
      tables: {
        headers: [
          { text: 'Название', value: 'name', sortable: false, align: 'left' },
          { text: 'Серийный номер', value: 'barcode_code', sortable: false, align: 'left' },
          { text: 'Кол-во', value: 'quantity', sortable: false, align: 'center' },
          { text: '', value: 'actions', sortable: false, align: '' },
        ],
      },
    };
  },
  methods: {
    /**
     * Получение уникальных кодов товара
     * @param product - объект товара
     * @returns {{code: null | string, id: null | number}}
     */
    // GetBarcode(product) {
    //   if (product.barcode_id) {
    //     return { id: product.barcode_id, code: product.barcode_code };
    //   }
    //   if (product.barcode && product.barcode.id) {
    //     return { id: product.barcode.id, code: product.barcode.code };
    //   }
    //   return { id: null, code: null };
    // },
  },
};
</script>
<style lang="scss">
</style>
